export default __webpack_public_path__ + "static/media/history_back.a0cc64b8.svg";